export default [
  {
    path: '/dashboard/admin-dkp',
    name: 'dashboard-admin-dkp',
    component: () => import('@/views/dashboards/DashboardAdminDKP.vue'),
    meta: {
      pageTitle: 'Dashboard Administrativo',
      action: 'manage',
      resource: 'all',
    },
  },
  {
    path: '/dashboard/executivo',
    name: 'dashboard-executivo',
    component: () => import('@/views/dashboards/DashboardAdminHanes.vue'),
    meta: {
      pageTitle: 'Dashboard Executivo',
      action: 'read',
      resource: 'AdminHanes',
    },
  },
  {
    path: '/dashboard/mural',
    name: 'dashboard-mural',
    component: () => import('@/views/dashboards/DashboardMural.vue'),
    meta: {
      pageTitle: 'Mural Institucional',
      action: 'read',
      resource: 'DashboardEquipeVendas',
    },
  },
  {
    path: '/dashboard/equipe-vendas',
    name: 'dashboard-equipe-vendas',
    component: () => import('@/views/dashboards/DashboardEquipeVendas.vue'),
    meta: {
      pageTitle: 'Dashboard de Vendas',
      action: 'read',
      resource: 'DashboardEquipeVendas',
    },
  },
  {
    path: '/dashboard/cliente',
    name: 'dashboard-cliente',
    component: () => import('@/views/dashboards/DashboardClienteHanes.vue'),
    meta: {
      pageTitle: 'Minha Conta',
      action: 'read',
      resource: 'DashboardCliente',
    },
  },
];
